export class IndentRequest{
    indentId: number;
    grnCompleted?: boolean;
    updatedUser?: string;
    versionFlag?: number;
    isActive?: boolean;
    cancelReason?:number
}